
import React, { lazy } from 'react';
import { LoadComponent, type RouteObject } from 'Routes/index';

const Admins = lazy(() => import(`Pages/Admin/Admins/Page`));

const AdminsRoutes: RouteObject[] = [
    {
        path: 'administradores',
        element: <LoadComponent component={Admins} />,
    },
]

export default AdminsRoutes;
